import { SubjectAndLevel } from "../../models/SubjectAndLevel";

const getSlugData = (slug): SubjectAndLevel => {
  let filteredSlugs: SubjectAndLevel = { subject: "", level: "" };
  if (noSubjectOrLevelInSlug(slug)) {
    return filteredSlugs;
  }
  if (oneValueInSlug(slug)) {
    // Checking if the only desired value in the slug is a level or subject as it could be either
    if (isLevel(slug[0])) {
      filteredSlugs = setLevel(slug[0]);
      return filteredSlugs;
    } else {
      filteredSlugs = setSubject(slug[0]);
      return filteredSlugs;
    }
  }
  filteredSlugs = setSubjectAndLevel(slug[0], slug[1]);
  return filteredSlugs;
};

const allLevels = [
  "A-Level",
  "GCSE",
  "University",
  "IB",
  "KS3",
  "National-4-and-5",
  "Scottish-Highers",
  "Mentoring",
  "13-Plus",
  "11-plus",
  "KS2",
];

const noSubjectOrLevelInSlug = (slug) => {
  return !slug || slug[0] === "view-tutors" || slug[0] === undefined;
};

const oneValueInSlug = (slug) => {
  // Covering both scenarios for when "view-tutors"/basepath is in the slug and not
  return slug.length === 1 || (slug.length >= 2 && slug[1] === "view-tutors");
};

const isLevel = (input: string) => {
  return allLevels.includes(input);
};

const setSubject = (input: string) => {
  return { subject: input, level: "" };
};

const setLevel = (input: string) => {
  return { subject: "", level: input };
};

const setSubjectAndLevel = (inputSubject: string, inputLevel: string) => {
  return { subject: inputSubject, level: inputLevel };
};

export default getSlugData;
